import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {faFileInvoiceDollar, faSkull} from "@fortawesome/pro-light-svg-icons";
import SpinnerButton from "../../../utilities/buttons/SpinnerButton";
import {bindActionCreators} from "redux";
import {
    loadingActionLoadUserAccountBalanceFromServer,
    loadingActionLoadUserWithdrawFromServer
} from "../../../../autoGenerated/actions/resourceLoadingActions";
import {connect} from "react-redux";
import {getAdminPath} from "../../../../api/adminAPI";
import {axiosInstance} from "../../../../utilities/axiosInstance";
import toast from "react-hot-toast";
import * as Sentry from "@sentry/browser";
import {faTimes} from "@fortawesome/pro-regular-svg-icons";
import {
    USER_WITHDRAW_STATE_PENDING,
    USER_WITHDRAW_STATE_USER_INFO_NEEDED
} from "../../../../constants/paymentConstants";


const AdminCancelUserWithdrawalButton = ({
                                              userWithdrawal,
                                              loadingActionLoadUserWithdrawFromServer,
                                              loadingActionLoadUserAccountBalanceFromServer
                                          }) => {
    const buttonEnabled = userWithdrawal.state === "pending" || userWithdrawal.state === "payment_pending";
    const [showDialog, setShowDialog] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);

    if(userWithdrawal.state !== USER_WITHDRAW_STATE_PENDING && userWithdrawal.state !== USER_WITHDRAW_STATE_USER_INFO_NEEDED){
        return (
            <SpinnerButton
                // Non-button props
                showSpinner={showSpinner}
                useDangerColor={true}

                // Button props
                // onClick={handleOpen}
                color={'secondary'}
                autoFocus={false}
                variant={'contained'}
                disabled={true}
            >
                <FontAwesomeIcon
                    icon={faTimes}
                    fixedWidth
                />
                &nbsp;Cancel Withdrawal
            </SpinnerButton>
        )
    }

    return (
        <React.Fragment>
            <SpinnerButton
                // Non-button props
                showSpinner={showSpinner}
                useDangerColor={true}

                // Button props
                onClick={handleOpen}
                color={'secondary'}
                autoFocus={false}
                variant={'contained'}
                disabled={!buttonEnabled | showSpinner}
            >
                <FontAwesomeIcon
                    icon={faTimes}
                    fixedWidth
                />
                &nbsp;Cancel Withdrawal
            </SpinnerButton>

            <Dialog
                open={showDialog}
                onClose={handleClose}
                aria-labelledby="jeff-credit-dialog-title"
                aria-describedby="jeff-credit-description"
            >
                <DialogTitle id="account-dialog-title">Cancel User Withdrawal?</DialogTitle>
                <DialogContent>
                    Are you sure you want to cancel this user withdrawal?
                    <br/>
                    <br/>

                    <Button
                        color="secondary"
                        onClick={handleConfirm}
                        disabled={!buttonEnabled}
                    >
                        <FontAwesomeIcon
                            icon={faSkull}
                            fixedWidth
                        />
                        &nbsp;Yes, Cancel It
                    </Button>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );

    function handleOpen() {
        setShowDialog(true);
    }

    function handleClose() {
        setShowDialog(false);
    }

    function handleConfirm() {
        setShowDialog(false);
        setShowSpinner(true);

        const baseURL = `jeff/withdrawal/${userWithdrawal.withdraw_uid}/cancel`;
        const callURL = getAdminPath(baseURL);

        const postPromise = axiosInstance.delete(callURL, {})
            .then(function (response) {
                loadingActionLoadUserWithdrawFromServer(userWithdrawal.withdraw_uid).then(() => {
                    setShowSpinner(false);
                    setShowSpinner(false);
                })

                loadingActionLoadUserAccountBalanceFromServer(userWithdrawal.account_uid);
            })
            .catch(function (error) {
                setShowSpinner(false);
                setShowSpinner(false);

                Sentry.withScope(scope => {
                    scope.setExtra("response", error.response);
                    Sentry.captureException(error);
                });

                toast.error('Failed');
            });

        toast.promise(
            postPromise,
            {
                loading: 'Cancelling...',
                success: 'Cancelled',
                error: 'Unable to cancel',
            }
        ).then(() => {
            setShowSpinner(false);
        });

    }
};


const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators({
        loadingActionLoadUserWithdrawFromServer: loadingActionLoadUserWithdrawFromServer,
        loadingActionLoadUserAccountBalanceFromServer: loadingActionLoadUserAccountBalanceFromServer
    }, dispatch);
};

export default connect(null, mapActionsToProps)(AdminCancelUserWithdrawalButton);